module.exports = __webpack_public_path__ + "7d4aeb6de2938e3b6daefa575884ba05.png";